import OrchestratorAPI from './common.js';
import {
  type CreateValues,
  type DocumentTemplateConfiguration,
  type DocumentTemplateConfigurationHistory,
  type FindAllOptions,
  type UpdateValues,
} from '../models/orchestrator/documentTemplateConfiguration.js';

const documentTemplateConfigurationDateFields: (keyof DocumentTemplateConfiguration)[] = [
  'created',
  'updated',
  'deleted',
];
const documentTemplateConfigurationHistoryDateFields: (keyof DocumentTemplateConfigurationHistory)[] =
  [
    'created',
    'documentTemplateConfigurationCreated',
    'documentTemplateConfigurationDeleted',
    'updated',
  ];

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/document-template-configurations';
  public readonly baseEndpoint = `${this.BASE_URL}${this.API_PATH}`;

  async findAll(options: FindAllOptions): Promise<DocumentTemplateConfiguration[]> {
    const url = this.constructPath('/', options);
    const { documentTemplateConfigurations } = await this.common.getJSON(url);
    return documentTemplateConfigurations.map((configuration: any) =>
      this.deserialize(configuration, {
        dateFields: documentTemplateConfigurationDateFields,
      })
    );
  }

  async findOneById(id: string): Promise<DocumentTemplateConfiguration> {
    const url = this.constructPath(`/${id}`);
    const { documentTemplateConfiguration } = await this.common.getJSON(url);
    return this.deserialize(documentTemplateConfiguration, {
      dateFields: documentTemplateConfigurationDateFields,
    });
  }

  async findHistory(id: string): Promise<DocumentTemplateConfigurationHistory[]> {
    const url = this.constructPath(`/${id}/history`);
    const { documentTemplateConfigurationHistory } = await this.common.getJSON(url);
    return documentTemplateConfigurationHistory.map((history: any) =>
      this.deserialize(history, {
        dateFields: documentTemplateConfigurationHistoryDateFields,
      })
    );
  }

  async create(values: CreateValues): Promise<DocumentTemplateConfiguration> {
    const url = this.constructPath('/');
    const { documentTemplateConfiguration } = await this.common.postJSON(url, values);
    return this.deserialize(documentTemplateConfiguration, {
      dateFields: documentTemplateConfigurationDateFields,
    });
  }

  async update(id: string, values: UpdateValues): Promise<DocumentTemplateConfiguration> {
    const url = this.constructPath(`/${id}`);
    const { documentTemplateConfiguration } = await this.common.patchJSON(url, values);
    return this.deserialize(documentTemplateConfiguration, {
      dateFields: documentTemplateConfigurationDateFields,
    });
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return await this.common.deleteJSON(url);
  }
}
